export const NAME = 'persons'

// Waiter call names
export const GET_ALL_PERSONS = 'GET_ALL_PERSONS'
export const GET_ALL_PERSONS_BY_COMPANY_ID = 'GET_ALL_PERSONS_BY_COMPANY_ID'
export const GET_PERSON = 'GET_PERSON'
export const GET_FAMILY = 'GET_FAMILY'
export const SEND_WELCOME_EMAIL = 'SEND_WELCOME_EMAIL'
